/**
 * Normalise tag strings so "Group" / "group " / "GROUP" don't fork.
 */
export const normaliseTag = (raw) => (raw || "").trim().toLowerCase().replace(/\s+/g, " ")
